(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["cavera-storelocator"] && !window.DesignMode) return;
  try {
         

    let address = document.querySelector('.address')
    let errortext = document.querySelector('.errortext')
    let loadingcont = document.querySelector('.loadingcont input')
    let clearsearch = document.querySelector('.clearsearch')
    let panel = document.getElementById('panel')
    let findlocbtn = document.querySelector('.findlocbtn')

    var latrad = 0;
    var lngrad = 0;

    const radiusSelect = document.getElementById("radius"); // get the select element
    let selectedRadius = parseInt(radiusSelect.value);
    selectedRadius = selectedRadius * 1000;
    // store the initial selected value in a variable

    let spinner = false

    const storeUrl = 'https://store-locator.caveraprojects.com?action=json&shopifystore=rockthelocks'

    window.initMap = function () {


    //loading function for find location icon  
    function loadingfn() {

      if (spinner == false) {
        loadingcont.classList.remove('loading')
        findlocbtn.style.background =
          "#EB63B0 url('https://cdn.shopify.com/s/files/1/0582/7854/3497/files/button_1.png?v=1655478729')"
      } else if (spinner == true) {
        loadingcont.classList.add('loading')
        findlocbtn.style.background =
          "#EB63B0 url('https://cdn.shopify.com/s/files/1/0582/7854/3497/files/loading.gif?v=1655501695')"
      }
    }
    loadingfn()


      //1
      const workerURL = URL.createObjectURL(new Blob([`
function request(url) {
return fetch(url).then(response => response.json());
}

onmessage = async function(event) {
const url = event.data.url;
const result = await request(url);
postMessage(result);
};
`]));
      const worker = new Worker(workerURL);

      //2
      worker.postMessage({
        url: storeUrl
      });

      loadingcont.value = ''
      // Create the map.
      const map = new google.maps.Map(document.getElementById('map'), {
        zoom: 3,
        // google.maps.center: { lat: 39.0007982, lng: -94.5499846 },
        //center: { lat: 0, lng: 0 },
        center: {
          lat: 39.8283,
          lng: -98.5795
        },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false
      })

      //3
      worker.onmessage = function (event) {

        let markerCluster;

        response = event.data;
        //console.log(response)

        var markers = [];
        response.features.forEach(feature => {
          var g = feature.geometry.coordinates;
          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(g[1], g[0]),
            icon: {
              url: 'https://maps.google.com/mapfiles/ms/icons/pink-dot.png',
              //scaledSize: new google.maps.Size(30, 40)
            },
            // adjust zIndex to be above other markers
            zIndex: Number(google.maps.Marker.MAX_ZINDEX)
          });
          markers.push(marker);

          google.maps.event.addListener(marker, 'click', function (event) {
            //console.log('marker clicked');

            const category = feature.properties.category
            const name = feature.properties.name
            const address = feature.properties.address
            const hours = feature.properties.hours
            const phone = feature.properties.phone
            const position = feature.geometry.coordinates

            var newpos = {
              lat: position[1],
              lng: position[0]
            }

            let markeradd = name + address
            markeradd = markeradd
              .replace(/[^\w\s]|_/g, '')
              .replace(/\s+/g, '')

            markeradd = markeradd.toLowerCase()

            let coladdresses = document.querySelectorAll('.coladdress')
            coladdresses.forEach(coladd => {
              let storewrap = coladd.closest('.storeinfo')

              let strnme = storewrap.querySelector('.thestorename')

              strnme = strnme.innerHTML
                .replace(/[^\w\s]|_/g, '')
                .replace(/\s+/g, '')

              coladd.closest('.storeinfo').style.backgroundColor = '#fff'

              let coladdcon = coladd.innerHTML
                .replace(/[^\w\s]|_/g, '')
                .replace(/\s+/g, '')
              coladdcon = strnme + coladdcon

              coladdcon = coladdcon.toLowerCase()

              if (markeradd === coladdcon) {
                if (window.innerWidth > 990) {
                  storewrap.scrollIntoView({
                    behavior: 'instant',
                    block: 'center',
                    inline: 'nearest'
                  })
                } else if (window.innerWidth < 990) {
                  //thecoladd.scrollTop = 0;
                  let element = storewrap.closest('.storeinfo')
                  const container = element.parentElement
                  const elementTop = element.offsetTop
                  const containerTop = container.offsetTop
                  container.scrollTop = elementTop - containerTop
                }
                let coladgbg = coladd.closest('.storeinfo')
                coladgbg.style.backgroundColor = '#ebebeb'
              }
            })

            //alert(markeradd)

            const content = `<div style="max-width:320px;">
            <h2 style="font-size:16px;">${name}</h2>
            <div class="infowindowcontent">
            <div>
            <div style="display:flex;flex-direction:column;padding-bottom:10px;">
            <strong>Address:</strong> ${address}
            </div>
            <div class="checkphone" style="padding-bottom:5px;"><strong>Phone: </strong><span>${phone}</span></div>
            <div style="padding-bottom:5px;margin-top:5px;font-size:15px;"><a href="https://www.google.com/maps/dir//${encodeURIComponent(address)}" target="_blank" style="text-decoration:underline;">Get Directions</a></div>
            </div>
            </div>
            </div>`

            infoWindow.setContent(content)
            infoWindow.setPosition(newpos)

            infoWindow.setOptions({
              pixelOffset: new google.maps.Size(0, -30)
            })
            infoWindow.open(map)
          })

        })

        markers.forEach(marker => {
          marker.setMap(map);
        });

        //markerCLustering
        markerCluster = new markerClusterer.MarkerClusterer({
          map,
          markers
        })

        //disable touch zoom:
        if(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)){
          map.set('gestureHandling', 'none');
        }

        // Define the custom marker icons, using the store's "category".
        map.data.setStyle(feature => {
          return {
            visible: false
          }
        })

        document
          .querySelector('.findlocbtn')
          .addEventListener('click', locatorButtonPressed)

        function populateAddress(lat, long) {
          fetch(
              'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
              lat +
              ',' +
              long +
              '&key=AIzaSyDP7ZIhVF5UjFZZLaKa15ZJQpdrHfxU_ls'
            )
            .then(response => {
              return response.json()
            })
            .then(response => {
              if (response.error_message) {
                error = response.error_message
                errortext = error
              } else {
                address.value = response.results[0].formatted_address
              }
            })
            .catch(error => {
              error = error.message
              errortext = error
              spinner = false
              loadingfn()
            })
        }

        //locator button pressed
        async function locatorButtonPressed() {
          infoWindow.close()
          errortext.textContent = ''

          spinner = true
          loadingfn()

          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              async position => {
                  latrad = position.coords.latitude
                  lngrad = position.coords.longitude

                  let markerLoc = new google.maps.LatLng(
                    position.coords.latitude,
                    position.coords.longitude
                  )
                  populateAddress(
                    position.coords.latitude,
                    position.coords.longitude
                  )


                  await runPlacesChanged(position.coords.latitude, position.coords.longitude)
                  //let markerLoc = new google.maps.LatLng(40.158432, -83.0889065);

                  const circle = new google.maps.Circle({
                    map: map,
                    radius: selectedRadius, // initial radius in meters
                    center: {
                      lat: position.coords.latitude,
                      lng: position.coords.longitude,
                    }, // center of the circle
                  });

                  // Get circle bounds
                  const circleBounds = circle.getBounds();

                  // Calculate width and height of the bounding box
                  const width = Math.abs(circleBounds.getNorthEast().lng() - circleBounds.getSouthWest().lng());
                  const height = Math.abs(circleBounds.getNorthEast().lat() - circleBounds.getSouthWest()
                    .lat());

                  // Set bounds of the map to the bounding box

                  // Adjust map zoom level to fit the bounding box
                  const maxZoom = 14; // maximum zoom level
                  const minZoom = 2; // minimum zoom level
                  const bounds = map.getBounds();
                  const boundsWidth = Math.abs(bounds.getNorthEast().lng() - bounds.getSouthWest().lng());
                  const boundsHeight = Math.abs(bounds.getNorthEast().lat() - bounds.getSouthWest().lat());
                  const zoomWidth = Math.log2(map.getDiv().offsetWidth / boundsWidth);
                  const zoomHeight = Math.log2(map.getDiv().offsetHeight / boundsHeight);
                  const newZoom = Math.min(Math.max(Math.round(Math.min(zoomWidth, zoomHeight)), minZoom),
                    maxZoom);
                  map.setZoom(newZoom);

                  map.fitBounds(circleBounds);

                  map.setCenter(markerLoc)
                  //console.log(selectedRadius)

                  originMarker.setPosition(markerLoc)
                  originMarker.setVisible(true)
                  circle.setMap(null);

                  spinner = false
                  loadingfn()

                  setTimeout(() => {
                    addClickEventsOnStoreDetails()
                  }, 0)
                },
                error => {
                  error =
                    'Locator is unable to find your address, please type your address manually'
                  errortext.textContent = error
                  setTimeout(() => {
                    loadingcont.value = ''
                  }, 3000)
                  spinner = false
                  loadingfn()
                }
            )
          } else {
            error = error.message
            errortext.textContent = error
          }
        }

        const apiKey = 'AIzaSyDP7ZIhVF5UjFZZLaKa15ZJQpdrHfxU_ls'
        const infoWindow = new google.maps.InfoWindow()

        function addClickEventsOnStoreDetails() {
          let storeinfo = document.querySelectorAll('.storeinfo')

          storeinfo.forEach(storedet => {
            storedet.addEventListener('click', e => {
              //console.log('column');
              const siblings =
                storedet.parentNode.querySelectorAll('.storeinfo')
              siblings.forEach(sibling => {
                if (sibling !== storedet) {
                  sibling.style.backgroundColor = '#fff'
                }
              })
              // Set background color for the clicked element
              storedet.style.backgroundColor = '#ebebeb'

              let theid = e.target.getAttribute('id')
              if (theid) {
                let thelat = e.target.getAttribute('data-lat')
                let thelong = e.target.getAttribute('data-long')
                let markerLoc = new google.maps.LatLng(thelat, thelong)
                //let fakeMarker = new google.maps.MVCObject();
                let selectedFeature = getfeaturebyid(theid)
                //console.log(selectedFeature)
                //const category = selectedFeature.properties.category
                const name = selectedFeature.properties.name
                const address = selectedFeature.properties.address
                const hours = selectedFeature.properties.hours
                const phone = selectedFeature.properties.phone
                const position = markerLoc

                const content = `<div style="max-width:320px;">
                <h2 style="font-size:16px;">${name}</h2>
                <div class="infowindowcontent">
                <div>
                <div style="display:flex;flex-direction:column;padding-bottom:10px;">
                <strong>Address:</strong> ${address}
                </div>
                <div class="checkphone" style="padding-bottom:5px;"><strong>Phone: </strong><span>${phone}</span></div>
                <div style="padding-bottom:5px;margin-top:5px;font-size:15px;"><a href="https://www.google.com/maps/dir//${encodeURIComponent(address)}" target="_blank" style="text-decoration:underline;">Get Directions</a></div>
                </div>
                </div>
                </div>`

                infoWindow.setContent(content)
                infoWindow.setPosition(position)

                infoWindow.setOptions({
                  pixelOffset: new google.maps.Size(0, -30)
                })
                infoWindow.open(map)
              }
            })
          })
        }

        //radius
        radiusSelect.addEventListener("change",  function () {

          errortext.textContent = ''

          selectedRadius = this.value;

          selectedRadius = parseInt(selectedRadius * 1000)
          //console.log(selectedRadius)
          let mylocaddress = address.value

          if (!mylocaddress) return
          
          let results;
          async function main() {

            async function getLatLongFromAddress(address) {
              const apiKey = 'AIzaSyDP7ZIhVF5UjFZZLaKa15ZJQpdrHfxU_ls';
              const url =
                `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${apiKey}`;
              const response = await fetch(url);
              const data = await response.json();
              const location = data.results[0].geometry.location;
              const lat = location.lat;
              const lng = location.lng;
              return {
                lat,
                lng
              };
            }
            results = await getLatLongFromAddress(mylocaddress);
          }
          main().then(() => {

             runPlacesChanged(results.lat, results.lng)
          });
        })


        //search bar
        const input = document.getElementById('autocomplete')

        const options = {
          types: ['address'],
          componentRestrictions: {
            country: 'us'
          }
        }

        // Make the search bar into a Places Autocomplete search bar and select
        // which detail fields should be returned about the place that
        // the user selects from the suggestions.
        const autocomplete = new google.maps.places.Autocomplete(input, options)

        autocomplete.setFields(['address_components', 'geometry', 'name'])

        // Set the origin point when the user selects an address
        const originMarker = new google.maps.Marker({
          map: map
        })
        originMarker.setVisible(false)
        let originLocation = map.getCenter()

        autocomplete.addListener('place_changed', runPlacesChanged)

        async function runPlacesChanged($lat, $lng) {

          if (address.value === '') return
          const place = autocomplete.getPlace()
          
          if (place) {

            errortext.textContent = '';

            infoWindow.close()

            if (!place.geometry) {
              // User entered the name of a Place that was not suggested and
              // pressed the Enter key, or the Place Details request failed.

              var form = document.getElementById('myForm')
              form.addEventListener('submit', event => {
                event.preventDefault()
                let findlocbtn = document.querySelector('.findlocbtn')
                findlocbtn.style.background =
                  "#ff5a5f url('https://cdn.shopify.com/s/files/1/0582/7854/3497/files/button_1.png?v=1655478729')"
              })

              errortext.textContent = `No address available for: "${place.name}". Please enter a new address.`

              setTimeout(() => {
                loadingcont.value = ''
              }, 3000)

              return

              // window.alert("No address available for input: '" + place.name + "'")
              // return
            }

            // Recenter the map to the selected addres
            originLocation = place.geometry.location

            latrad = place.geometry.location.lat();
            lngrad = place.geometry.location.lng();

            const circle = new google.maps.Circle({
              map: map,
              radius: selectedRadius, // initial radius in meters
              center: {
                lat: latrad,
                lng: lngrad
              }, // center of the circle
            });

            // Get circle bounds
            const circleBounds = circle.getBounds();

            // Calculate width and height of the bounding box
            const width = Math.abs(circleBounds.getNorthEast().lng() - circleBounds.getSouthWest().lng());
            const height = Math.abs(circleBounds.getNorthEast().lat() - circleBounds.getSouthWest().lat());

            // Set bounds of the map to the bounding box

            // Adjust map zoom level to fit the bounding box
            const maxZoom = 14; // maximum zoom level
            const minZoom = 2; // minimum zoom level
            const bounds = map.getBounds();
            const boundsWidth = Math.abs(bounds.getNorthEast().lng() - bounds.getSouthWest().lng());
            const boundsHeight = Math.abs(bounds.getNorthEast().lat() - bounds.getSouthWest().lat());
            const zoomWidth = Math.log2(map.getDiv().offsetWidth / boundsWidth);
            const zoomHeight = Math.log2(map.getDiv().offsetHeight / boundsHeight);
            const newZoom = Math.min(Math.max(Math.round(Math.min(zoomWidth, zoomHeight)), minZoom), maxZoom);
            map.setZoom(newZoom);

            map.fitBounds(circleBounds);

            map.setCenter(originLocation)
            //console.log(selectedRadius)

            originMarker.setPosition(originLocation)
            originMarker.setVisible(true)
            circle.setMap(null);

          } else {

            const circle = new google.maps.Circle({
              map: map,
              radius: selectedRadius, // initial radius in meters
              center: {
                lat: $lat,
                lng: $lng
              }, // center of the circle
            });

            // Get circle bounds
            const circleBounds = circle.getBounds();

            // Calculate width and height of the bounding box
            const width = Math.abs(circleBounds.getNorthEast().lng() - circleBounds.getSouthWest().lng());
            const height = Math.abs(circleBounds.getNorthEast().lat() - circleBounds.getSouthWest().lat());

            // Set bounds of the map to the bounding box
            map.fitBounds(circleBounds);

            // Adjust map zoom level to fit the bounding box
            const maxZoom = 14; // maximum zoom level
            const minZoom = 2; // minimum zoom level
            const bounds = map.getBounds();
            const boundsWidth = Math.abs(bounds.getNorthEast().lng() - bounds.getSouthWest().lng());
            const boundsHeight = Math.abs(bounds.getNorthEast().lat() - bounds.getSouthWest().lat());
            const zoomWidth = Math.log2(map.getDiv().offsetWidth / boundsWidth);
            const zoomHeight = Math.log2(map.getDiv().offsetHeight / boundsHeight);
            const newZoom = Math.min(Math.max(Math.round(Math.min(zoomWidth, zoomHeight)), minZoom), maxZoom);
            map.setZoom(newZoom);
            circle.setMap(null);

          }
          //directionsRoutefunc()
          await loadStores()

          addClickEventsOnStoreDetails()

        }

        function getfeaturebyid(id) {
          let obj = response.features.find(obj => obj.properties.number == id)
          return obj
        }

        function loadStores() {

          infoWindow.close()

          spinner = true
          loadingfn()

          // fetch(storeUrl)
          //   .then(response => response.json())
          //   .then(jsonData => {
          //     storeData = jsonData;
          let storeHTML = '';
          let counter = 0; // initialize counter variable

          // Wait for the map to load before calling getBounds()
          google.maps.event.addListenerOnce(map, 'idle', function () {
            const bounds = map.getBounds();

            if (!address.value) {

              for (let content of response.features) {
                //console.log("DATA", content)
                const lat = content.geometry.coordinates[1];
                const lng = content.geometry.coordinates[0];
                const pos = new google.maps.LatLng(lat, lng);

                // Check if the marker is inside the viewport
                if (bounds.contains(pos)) {
                  storeHTML += `<div class="storeinfo" id="${content.properties.number}" data-lat="${lat}" data-long="${lng}">
                  <p class="thestorename" style="padding-bottom:5px;">${content.properties.name}</p>
                  <p style="padding-bottom:5px;"><strong style="display:block;">Address: </strong><span class="coladdress"> ${content.properties.address}</span></p>
                  <p class="checkphone" style="padding-bottom:5px;"><strong>Phone: </strong><span>${content.properties.phone}</span></p>
                  </div>`;
                }
              }

              panel.innerHTML = storeHTML;

              if (!panel.innerHTML) {
                panel.innerHTML =
                  `<div style="padding:10px; text-align:center; font-size:16px;">No Stores found, please expand search radius or zoom out of map</div>`
              }
              addClickEventsOnStoreDetails();
              
            } else {
              let mylocaddress = address.value
              let results;
              async function main() {

                async function getLatLongFromAddress(address) {
                  const apiKey = 'AIzaSyDP7ZIhVF5UjFZZLaKa15ZJQpdrHfxU_ls';
                  const url =
                    `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${apiKey}`;
                  const response = await fetch(url);
                  const data = await response.json();
                  const location = data.results[0].geometry.location;
                  const lat = location.lat;
                  const lng = location.lng;
                  return {
                    lat,
                    lng
                  };
                }
                results = await getLatLongFromAddress(mylocaddress);
              }
              main().then(() => {
                //alert(`lat:${results.lat}, lng:${results.lng}`)
                const origin = new google.maps.LatLng(results.lat, results
                  .lng); // Replace with your own origin coordinates

                // Access the `features` array inside the `storeData` object
                const storeDataFeatures = response.features;

                storeDataFeatures.forEach(store => {
                  const storeLatLng = new google.maps.LatLng(store.geometry.coordinates[1], store
                    .geometry.coordinates[0]);
                  const distanceInMeters = google.maps.geometry.spherical.computeDistanceBetween(origin,
                    storeLatLng);
                  const distanceInMiles = distanceInMeters / 1609.344;
                  store.distance = distanceInMiles.toFixed(1);
                });

                for (let i = 0; i < markers.length; i++) {
                  markers[i].setMap(null);
                }

                markerCluster.clearMarkers();

                // Sort the storeData array by distance, in ascending order
                storeDataFeatures.sort((a, b) => a.distance - b.distance);

                // Generate the HTML for each store, in order of distance from the origin
            
                for (let store of storeDataFeatures) {

                  // Check if the marker is inside the viewport
                  const lat = store.geometry.coordinates[1];
                  const lng = store.geometry.coordinates[0];
                  const pos = new google.maps.LatLng(lat, lng);

                  
                  if (bounds.contains(pos)) {
                    if (counter < 10) { // limit to top ten markers
                      const marker = new google.maps.Marker({
                        position: {
                          lat,
                          lng
                        },
                        map: map,
                        title: store.properties.name,
                        icon: {
                          url: 'https://maps.google.com/mapfiles/ms/icons/pink-dot.png',
                          //scaledSize: new google.maps.Size(30, 40)
                        },
                        // adjust zIndex to be above other markers
                        zIndex: Number(google.maps.Marker.MAX_ZINDEX)

                      });
                      ////////

                      markers.push(marker); // add marker to markers array

                      // create the InfoWindow content string
                      const contentString = `<div style="max-width:320px;">
                      <h2 style="font-size:16px;">${store.properties.name}</h2>
                      <div class="infowindowcontent">
                      <div>
                      <div style="display:flex;flex-direction:column;padding-bottom:10px;">
                      <strong>Address:</strong> ${store.properties.address}
                      </div>
                      <div class="checkphone" style="padding-bottom:5px;"><strong>Phone: </strong><span>${store.properties.phone}</span></div>
                      <div style="padding-bottom:5px;margin-top:5px;font-size:15px;"><a href="https://www.google.com/maps/dir//${encodeURIComponent(store.properties.address)}" target="_blank" style="text-decoration:underline;">Get Directions</a></div>
                      </div>
                      </div>
                      </div>`

                      // declare a variable to hold the currently open InfoWindow
                      var openInfoWindow;

                      google.maps.event.addListener(marker, 'click', function () {
                        infoWindow.close()

                        // create a new InfoWindow object with the content
                        var infowindow = new google.maps.InfoWindow({
                          content: contentString
                        });
                        // close the currently open InfoWindow if there is one
                        if (openInfoWindow) {
                          openInfoWindow.close();
                        }
                        // set the current InfoWindow to the new one
                        openInfoWindow = infowindow;
                        // open the InfoWindow at the marker's position
                        infowindow.open(map, marker);

                        /////
                        let markeradd = store.properties.name + store.properties.address

                        markeradd = markeradd
                          .replace(/[^\w\s]|_/g, '')
                          .replace(/\s+/g, '')

                        markeradd = markeradd.toLowerCase()
                      // console.log("MARKERADD",markeradd)

                        let panel = document.getElementById("panel")
                        let coladdresses = panel.querySelectorAll('.coladdress')
                        coladdresses.forEach(coladd => {
                          let storewrap = coladd.closest('.storeinfo')

                          let strnme = storewrap.querySelector('.thestorename')

                          strnme = strnme.innerHTML
                            .replace(/[^\w\s]|_/g, '')
                            .replace(/\s+/g, '')

                          coladd.closest('.storeinfo').style.backgroundColor = '#fff'

                          let coladdcon = coladd.innerHTML
                            .replace(/[^\w\s]|_/g, '')
                            .replace(/\s+/g, '')
                          coladdcon = strnme + coladdcon

                          coladdcon = coladdcon.toLowerCase()
                          //console.log(markeradd, coladdcon)
                          if (markeradd === coladdcon) {
                            if (window.innerWidth > 990) {
                              storewrap.scrollIntoView({
                                behavior: 'instant',
                                block: 'center',
                                inline: 'nearest'
                              })
                            } else if (window.innerWidth < 990) {
                              //thecoladd.scrollTop = 0;
                              let element = storewrap.closest('.storeinfo')
                              const container = element.parentElement
                              const elementTop = element.offsetTop
                              const containerTop = container.offsetTop
                              container.scrollTop = elementTop - containerTop
                            }
                            let coladgbg = coladd.closest('.storeinfo')
                            coladgbg.style.backgroundColor = '#ebebeb'
                              }
                            })

                      });

                     
                      
                      storeHTML += `<div class="storeinfo" id="${store.properties.number}" data-lat="${lat}" data-long="${lng}">
                      <p class="thestorename" style="padding-bottom:5px;">${store.properties.name}</p>
                      <p style="padding-bottom:5px;"><strong style="display:block;">Address: </strong><span class="coladdress"> ${store.properties.address}</span></p>
                      <p class="checkphone" style="padding-bottom:5px;
                      "><strong>Phone: </strong><span>${store.properties.phone}</span></p>
                      <p class="" style="padding-bottom:5px;
                      "><strong>Distance: </strong><span><em>${store.distance} ${store.distance === 1.0 ? 'mile' : 'miles'} </em></span></p>                
                      </div>`;

                    }
                    counter++; // increment counter
                  }
                  if (counter === 10) break; 
                  // break out of loop once counter reaches 10

                }

                  panel.innerHTML = storeHTML;


                   ///close infor window func.
                   panel.addEventListener('click', () =>{
                        if(openInfoWindow){
                         openInfoWindow.close();
                        }
                        if (window.innerWidth < 990) {
                        setTimeout(() =>{
                        document.getElementById('map').scrollIntoView({
                          behavior: 'smooth',
                          block: 'center',
                          inline: 'nearest'
                        })
                       },0);
                      }
                      })

                addClickEventsOnStoreDetails();

                if (!panel.innerHTML) {
                  panel.innerHTML =
                    `<div style="padding:10px; text-align:center;font-size:16px;">No Stores found, please expand search radius or zoom out of map</div>`
                  
                  }

              });
            }
          });
          spinner = false
          loadingfn()
        }

        function addZoomChangeListener() {
          infoWindow.close()
          google.maps.event.addListenerOnce(map, 'idle', function () {
            google.maps.event.addListener(map, 'zoom_changed', function () {
              loadStores();
            });
          })
        }
        addZoomChangeListener();

        function addDragListener() {
          //infoWindow.close()
          google.maps.event.addListenerOnce(map, 'idle', function () {
            google.maps.event.addListener(map, 'drag', function () {
              loadStores();
            });
          });
        }
        addDragListener();

     
      clearsearch.addEventListener('click', () => {
          panel.innerHTML = ''
          errortext.textContent = ''
          radiusSelect.selectedIndex = 0;
          selectedRadius = 1000;
          window.initMap()
    
        })

      } //endworker
    } //end init func


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

})();
